import React, { PureComponent } from 'react';

import AvatarBase from './avatar-base';
import Tooltip from './tooltip';

import { fetchCurrentUser } from '../api/users-api';
import { fetchTeams } from '../api/teams-api';

const TeamEntry = props => {
    const handleClick = () => {
        if (props.loginRestrictedSSO) {
            return;
        }

        props.onClick && props.onClick(props.teamUrl);
    }
    return (
        <Tooltip
            disabled={!props.loginRestrictedSSO}
            placement="top"
            tooltip="You must login via SSO to access this team."
        >
            <div className={'team' + (props.loginRestrictedSSO ? ' disabled' : '')} data-team={props.teamUrl} onClick={handleClick}>
                <div className="team-body">
                    <AvatarBase image={props.logo} color={props.color} secondaryColor={props.secondaryColor} text={props.initials} team size="xlarge" />
                </div>

                <div className="team-foot">
                    {props.teamName}
                </div>
            </div>
        </Tooltip>
    );
}

export default class TeamSelector extends PureComponent {
    state = {
        userName: ''
    }

    async fetchTeams() {
        const { teams } = await fetchTeams({ limit: 100 });

        if (teams.items) {
            this.setState({
                teams: teams.items
            });
        }
    }

    componentDidMount() {
        fetchCurrentUser(true, this.props.masterToken)
            .then(user => {
                this.setState({
                    userName: user.name
                });
            });

        if (!this.props.teamTokens && this.props.masterToken) {
            this.fetchTeams();
        }
    }

    get teams() {
        if (this.props.teamTokens) {
            return this.props.teamTokens.map(({ team }) => team);
        }

        if (this.state.teams) {
            return this.state.teams;
        }

        return [];
    }

    render() {
        return (
            <div className="team-selector">
                <div className="team-selector-intro">
                    <h2>Welcome back, {this.state.userName}!</h2>

                    <p>Which team do you want to log in to?</p>
                </div>

                <div className="team-selector-body">
                    <div className="team-selector-teams">
                        {
                            this.teams.map(team => <TeamEntry
                                key={team.url}
                                teamUrl={team.url}
                                logo={team.logo}
                                color={team.color}
                                secondaryColor={team.secondary_color}
                                initials={team.initials}
                                teamName={team.name}
                                loginRestrictedSSO={team.sso_only && !this.props.ssoLogin && !team.isOwner}
                                onClick={this.props.onTeamClick}
                            />)
                        }

                        {
                            this.props.onNewTeamClick ? (
                                <TeamEntry
                                    key="new"
                                    initials="+"
                                    teamName="Create a New Team"
                                    onClick={this.props.onNewTeamClick}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}
